import { errorClassificationLookup, rejectionTypeToPolicyTypeMap } from '@ourbranch/lookups';

// BYPASS_ALERT and DISMISSIBLE_REJECTION only block navigation when relevant to the selected policy type.
// Other alert types (plain ALERT) always block
export function shouldAlertBlockNavigation(alert, policyType) {
  const alertType = errorClassificationLookup[Number(alert.code)];
  if (alertType === 'BYPASS_ALERT' || alertType === 'DISMISSIBLE_REJECTION') {
    return rejectionTypeToPolicyTypeMap[alert.type]?.includes(policyType) ?? false;
  }
  return true;
}

// The rater's missing-data cascade returns one code per round trip (5001 → 5002 → 5003 → ...).
// Map each code to the input that resolves it so the agent lands on the exact field instead of
// hunting through the revealed section. Omitted on purpose: 5001 (prior-address inputs hide
// behind the lived-here-1-year radio) and 5010 (the VIN is already filled and often correct —
// 5010 also fires on vendor failures, so focusing the field nudges agents to retype a good VIN;
// see #33196).
export const ALERT_FIELD_FOCUS_MAP = {
  5002: 'dateOfBirth',
  5003: 'policyLimitBIPD',
  5005: 'VIN',
  5006: 'VIN',
  5012: 'driversLicenseNumber',
  5015: 'driversLicenseState',
  5016: 'dateOfBirth',
  5023: 'home.latitude',
  5025: 'unit',
  50001: 'VIN'
};

// Section render happens after setSectionsToShow, so defer the DOM focus a tick (same pattern
// as ScrollToError's mount scroll). preventScroll leaves the section's own alert scroll as the
// visual anchor; marking the field touched makes its alert-schema "required" message render
// under the exact input immediately instead of on the next failed submit.
export function focusFirstAlertField(alerts, setFieldTouched) {
  const fieldId = alerts?.map((alert) => ALERT_FIELD_FOCUS_MAP[Number(alert.code)]).find(Boolean);
  if (!fieldId) {
    return;
  }
  setFieldTouched?.(fieldId, true, true);
  setTimeout(() => {
    document.getElementById(fieldId)?.focus({ preventScroll: true });
  }, 150);
}
